export default (value) => {
  if (!value) return '';
  const v = value.replace(/[^A-Z0-9]/gi, '');
  return v.replace(/^([A-Z0-9]{2})([A-Z0-9]{3})([A-Z0-9]{3})([A-Z0-9]{4})(\d{2})/i, '$1.$2.$3/$4-$5');
};
